import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Button, FilledInput, InputAdornment, CircularProgress as Loader } from "@material-ui/core";
import { Formik } from "formik";
import * as Yup from "yup";
import { Email } from "@material-ui/icons";

import { shareQrLink } from "store/actions";

function ShareQr({ network, handleModal }) {
    const dispatch = useDispatch();

    const { isLoading } = useSelector(({ loading }) => ({
        isLoading: loading,
    }));

    return (
        <>
            <Formik
                initialValues={{
                    email: "",
                }}
                validationSchema={Yup.object().shape({
                    email: Yup.string().email().required("Email address is required"),
                })}
                onSubmit={(value) => {
                    // value.network = network;
                    dispatch(shareQrLink(value));
                    handleModal();
                }}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, touched, values }) => (
                    <form onSubmit={handleSubmit}>
                        <FilledInput
                            autoComplete="off"
                            type="email"
                            fullWidth
                            placeholder="Enter Email Address"
                            name="email"
                            defaultValue={values.email}
                            onBlur={handleBlur}
                            onChange={handleChange}
                            startAdornment={
                                <InputAdornment position="start">
                                    <Email />
                                </InputAdornment>
                            }
                            required={true}
                            error={Boolean(touched.email && errors.email)}
                            disabled={isLoading}
                        />
                        {Boolean(touched.email && errors.email) ? (
                            <div
                                style={{
                                    display: "block",
                                    marginLeft: "10px",
                                    color: "red",
                                    fontSize: 13,
                                }}
                            >
                                {errors.email}
                            </div>
                        ) : (
                            ""
                        )}
                        <br />
                        <Box textAlign="center" marginTop="1.5rem" marginBottom="1.5rem">
                            <Button id="signin-btn" color="primary" variant="contained" onClick={handleSubmit}>
                                {isLoading ? <Loader color="secondary" size={20} /> : "Share QR code"}
                            </Button>
                        </Box>
                    </form>
                )}
            </Formik>
        </>
    );
}

export default ShareQr;
